/** Categorical piece colours, tuned for the dark CAD workspace. */
const PIECE_COLOURS = [0x4cc9f0, 0xf4a261, 0x80ed99, 0xf72585, 0xb388eb, 0xffd166, 0x2ec4b6, 0xff7b54, 0x90be6d, 0xe5989b];
/** The same hues, in the same order, deepened so they read on white paper. */
const PRINT_PIECE_COLOURS = ["#0a86b8", "#d4651a", "#2e9e4a", "#d0136a", "#7b4fc4", "#b8860b", "#138a7f", "#c0392b", "#5f8a2d", "#b5545a"];

const wrap = (index: number, length: number) => ((index % length) + length) % length;

export function pieceColour(index: number): number {
  return PIECE_COLOURS[wrap(index, PIECE_COLOURS.length)];
}

export function pieceColourCss(index: number): string {
  return `#${pieceColour(index).toString(16).padStart(6, "0")}`;
}

export function piecePrintColour(index: number): string {
  return PRINT_PIECE_COLOURS[wrap(index, PRINT_PIECE_COLOURS.length)];
}

/** Piece letter as printed: A–Z, then AA, AB… */
export function pieceLetter(index: number): string {
  let label = "";
  for (let n = index; n >= 0; n = Math.floor(n / 26) - 1) label = String.fromCharCode(65 + (n % 26)) + label;
  return label;
}
